import { render, staticRenderFns } from "./SingleDirectPaymentDetailPage.vue?vue&type=template&id=5b1583af&scoped=true&"
import script from "./SingleDirectPaymentDetailPage.vue?vue&type=script&lang=js&"
export * from "./SingleDirectPaymentDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./SingleDirectPaymentDetailPage.vue?vue&type=style&index=0&id=5b1583af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1583af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1583af')) {
      api.createRecord('5b1583af', component.options)
    } else {
      api.reload('5b1583af', component.options)
    }
    module.hot.accept("./SingleDirectPaymentDetailPage.vue?vue&type=template&id=5b1583af&scoped=true&", function () {
      api.rerender('5b1583af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/directPaymentDetailPages/SingleDirectPaymentDetailPage.vue"
export default component.exports